
import React from 'react';
import AdSenseAd from './AdSenseAd';
import { useSubscription } from '@/contexts/SubscriptionContext';
import { useConstructionMode } from '@/contexts/ConstructionModeContext';

interface AdSectionProps {
  adSlot: string;
  adFormat?: string;
  className?: string;
  position?: 'top' | 'middle' | 'bottom' | 'sidebar';
}

const AdSection: React.FC<AdSectionProps> = ({
  adSlot,
  adFormat = "auto",
  className = "",
  position = "middle"
}) => {
  const { isPremium } = useSubscription();
  const { isConstructionMode } = useConstructionMode();

  // Debug log to check subscription status
  console.log('AdSection - isPremium:', isPremium, 'isConstructionMode:', isConstructionMode, 'position:', position, 'adSlot:', adSlot);

  // Don't show ads for premium users
  if (isPremium) {
    console.log('Premium user detected - hiding ad for slot:', adSlot);
    return null;
  }

  // Don't show ads when site is under construction (Google AdSense policy compliance)
  if (isConstructionMode) {
    console.log('Construction mode active - hiding ad for slot:', adSlot);
    return null;
  }

  const getAdStyles = () => {
    switch (position) {
      case 'top':
        return "mb-8 border-b border-gray-100 pb-6 clear-both";
      case 'bottom':
        return "mt-8 border-t border-gray-100 pt-6 clear-both";
      case 'sidebar':
        return "sticky top-4";
      default:
        return "my-8 border border-gray-100 rounded-lg p-4 bg-gray-50/50 clear-both";
    }
  };

  console.log('Rendering ad for free user - position:', position, 'slot:', adSlot);

  return (
    <div className={`${getAdStyles()} ${className}`} style={{ position: 'relative', zIndex: 1 }}>
      <div className="text-center mb-3">
        <span className="text-xs text-gray-400 uppercase tracking-wide font-medium">Publicidad</span>
      </div>
      <AdSenseAd 
        adSlot={adSlot}
        adFormat={adFormat}
        className="w-full max-w-full overflow-hidden"
      />
    </div>
  );
};

export default AdSection;
